module.exports = __webpack_public_path__ + "img/dark.48aba4bc.jpg";